// Copyright (c) Qualcomm Technologies, Inc. and/or its subsidiaries.
// SPDX-License-Identifier: BSD-3-Clause-Clear

export const toastClasses = {
  action: "qui-toast__action",
  closeButton: "qui-toast__close-button",
  description: "qui-toast__description",
  icon: "qui-toast__icon",
  label: "qui-toast__label",
  root: "qui-toast__root",
} as const
